import { AudioManager } from './../../AudioManager';
import { Button } from "../../utils/Utils";
import { GameConstants } from "../../GameConstants";
import { SplashScene } from "./SplashScene";
import { GameVars } from "../../GameVars";

export class StartLayer extends Phaser.GameObjects.Container {

    private playButton: Button;

    constructor(scene: Phaser.Scene) {

        super(scene);

        let howToPlayImg = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "texture_atlas_language", "how_to_play");
        this.add(howToPlayImg);

        let text = GameVars.gameText.SPLASH[0];

        let howToPlayText = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + 30, text, {fontFamily: "HelveticaNeue", fontSize: "33px", color: "#5E290E", align: "center"});
        howToPlayText.setOrigin(.5);
        howToPlayText.setWordWrapWidth(600);
        this.add(howToPlayText);

        this.playButton = new Button(this.scene, 960, 765, "texture_atlas_1", "btn_play", "btn_play_hover");
        this.playButton.onDown(this.onClickPlay, this);
        this.add(this.playButton);
    }

    private onClickPlay(): void {
        
        SplashScene.currentInstance.showDifficultyLayer();
        AudioManager.playSound("click");
    }
}
